import PartnerDetail from "./PartnerDetail"
import RecurringDonation from "./RecurringDonation"

export { PartnerDetail, RecurringDonation }
